import { Menu, MenuItem } from '@pepper/ui'
import clsx from 'clsx'
import { FC } from 'react'
import {
  BooleanParam,
  NumberParam,
  useQueryParams,
  withDefault,
} from 'use-query-params'

import s from './SeoGuideLines.module.css'

type Props = {
  onChange: () => void
}

export const SeoGuideLines: FC<Props> = ({ onChange }) => {
  const [query, setQuery] = useQueryParams({
    crr_id: withDefault(BooleanParam, undefined),
    page: withDefault(NumberParam, 1),
  })

  const handleSubmit = (existsCrrId: boolean) => {
    setQuery({ crr_id: existsCrrId, page: 1 })
    onChange()
  }

  return (
    <Menu className={s.menu} triggerSubMenuAction="click">
      <MenuItem
        key="0"
        onClick={() => handleSubmit(true)}
        className={clsx(s.menuItem, {
          [s.active]: query.crr_id,
        })}
      >
        With report
      </MenuItem>
      <MenuItem
        active={true}
        key="1"
        onClick={() => handleSubmit(false)}
        className={clsx(s.menuItem, {
          [s.active]: query.crr_id === false,
        })}
      >
        Without report
      </MenuItem>
    </Menu>
  )
}
